export default "__VITE_ASSET__Cbp8iMd0__"